import { render } from "./IConcertSkeleton.vue?vue&type=template&id=5876f60e&scoped=true"
const script = {}

import "./IConcertSkeleton.vue?vue&type=style&index=0&id=5876f60e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5876f60e"]])

export default __exports__